export enum UserStatus {
  MEMBER = "member",
  MEMBER_PREMIUM = "member_premium",
}

export const MessageTargetValue = {
  ...UserStatus,
  FORMER_PREMIUM_MEMBER: 'former_premium_member',
};
export type MessageTarget = (typeof MessageTargetValue)[keyof typeof MessageTargetValue];